import React from 'react';
import { ActionCenterDiv, EndChatContainer, LineActionDiv } from './styles';
import { IoInformationCircleOutline } from 'react-icons/io5';

export const EndChatMessage = ({ message }) => {
  return (
    <EndChatContainer isAnswer={true}>
      <LineActionDiv />
      <ActionCenterDiv>
        <IoInformationCircleOutline />
        {message || 'Conversa encerrada'}
      </ActionCenterDiv>
      <LineActionDiv />
    </EndChatContainer>
  );
};
